'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('shared/styled/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalFooter = _styledComponents2.default.div(_templateObject());

var MandatorySign = _styledComponents2.default.span(_templateObject2(), function (props) {
  return props.theme.platformPrimary;
});

var MandatoryInfo = _styledComponents2.default.span(_templateObject3(), _colors2.default.gray.light);

exports.default = {
  ModalFooter: ModalFooter,
  MandatorySign: MandatorySign,
  MandatoryInfo: MandatoryInfo
};